import { ONE_MINUTE } from '@air/utilities';

import { type FinishedUploadBatch } from '~/components/v2/components/workspace/workspace-agent-panel/uploaded-batch-offer/useUploadedBatchOfferStore';

export const UPLOADED_BATCH_OFFER_VISIBLE_MS = ONE_MINUTE;

export type UploadedBatchOfferVisibilityParams = {
  batch: FinishedUploadBatch | null;
  isAgentIdle: boolean;
  /** The asset modal covers the rail, so the pill would float over it with no icon to point at. */
  isAssetViewOpen: boolean;
  isCreditsDepleted: boolean;
  isTrayClosing: boolean;
  isTrayOpen: boolean;
  now: number;
  resolvedBatchIds: ReadonlySet<string>;
};

export const isUploadedBatchOfferVisible = ({
  batch,
  isAgentIdle,
  isAssetViewOpen,
  isCreditsDepleted,
  isTrayClosing,
  isTrayOpen,
  now,
  resolvedBatchIds,
}: UploadedBatchOfferVisibilityParams): boolean => {
  if (batch === null) {
    return false;
  }

  if (resolvedBatchIds.has(batch.batchId)) {
    return false;
  }

  if (now >= batch.finishedAt + UPLOADED_BATCH_OFFER_VISIBLE_MS) {
    return false;
  }

  if (isAssetViewOpen) {
    return false;
  }

  if (isTrayOpen || isTrayClosing) {
    return false;
  }

  if (!isAgentIdle) {
    return false;
  }

  if (isCreditsDepleted) {
    return false;
  }

  return true;
};
